import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  defaultText: {
    id: 'LumaBot.LumaBotThread.defaultText',
    defaultMessage: 'LumaBot {title} completed',
  },
  startedAt: {
    id: 'LumaBot.LumaBotThread.startedAt',
    defaultMessage: 'Session started at {startedAt}',
  },
});
